var get_header_height = require('../helpers/_utils').get_header_height;

function scroll_to_pub(target) {
  var top = target.getBoundingClientRect().top + window.pageYOffset - get_header_height();
  window.scrollTo({ top: top, behavior: 'smooth' });
}

function open_fl_accordion(target, on_done) {
  var fl_item = target.closest('.fl-accordion-item');
  if (!fl_item) { on_done(); return; }

  var fl_btn = fl_item.querySelector('.fl-accordion-button-icon');
  if (!fl_btn || fl_btn.getAttribute('aria-expanded') !== 'false') { on_done(); return; }

  var panel_id = fl_btn.getAttribute('aria-controls');
  var panel = panel_id ? document.getElementById(panel_id) : null;
  if (!panel || !window.jQuery) { fl_btn.click(); on_done(); return; }

  // Close any other open accordion items in the same accordion without triggering BB's scroll
  var fl_accordion = fl_item.closest('.fl-accordion');
  if (fl_accordion) {
    fl_accordion.querySelectorAll('.fl-accordion-item.fl-accordion-item-active').forEach(function(other_item) {
      if (other_item === fl_item) return;
      var other_btn = other_item.querySelector('.fl-accordion-button-icon');
      var other_panel_id = other_btn && other_btn.getAttribute('aria-controls');
      var other_panel = other_panel_id ? document.getElementById(other_panel_id) : null;
      if (other_btn) other_btn.setAttribute('aria-expanded', 'false');
      other_item.classList.remove('fl-accordion-item-active');
      if (other_panel) window.jQuery(other_panel).slideUp();
    });
  }

  // Open the target accordion directly via jQuery — bypasses BB's click handler (which scrolls)
  fl_item.classList.add('fl-accordion-item-active');
  fl_btn.setAttribute('aria-expanded', 'true');
  window.jQuery(panel).slideDown(function() {
    on_done();
  });
}

function handle_publication_param() {
  var pub_id = new URLSearchParams(window.location.search).get('pub');
  if (!pub_id) return;

  var target = document.getElementById(pub_id);
  if (!target || !target.classList.contains('publication-item')) return;

  open_fl_accordion(target, function() {
    scroll_to_pub(target);
  });
}

function init_publications() {
  // Defer to next tick after window.load so BB's own load handlers
  // (which attach accordion listeners) have all run first
  window.addEventListener('load', function() {
    setTimeout(handle_publication_param, 0);
  });

  document.querySelectorAll('.publication-accordion-toggle').forEach(function(toggle) {
    toggle.addEventListener('click', function() {
      var summary = toggle.nextElementSibling;
      var icon = toggle.querySelector('.publication-accordion-icon');
      var expanded = toggle.getAttribute('aria-expanded') === 'true';

      toggle.setAttribute('aria-expanded', String(!expanded));
      icon.textContent = expanded ? '+' : '−';

      if (expanded) {
        summary.style.height = summary.scrollHeight + 'px';
        summary.offsetHeight; // force reflow
        summary.classList.remove('is-open');
        summary.style.height = '0';
      } else {
        summary.classList.add('is-open');
        var target_height = summary.scrollHeight;
        summary.style.height = target_height + 'px';
        summary.addEventListener('transitionend', function on_end(e) {
          if (e.propertyName === 'height') {
            summary.style.height = 'auto';
            summary.removeEventListener('transitionend', on_end);
          }
        });
      }
    });
  });
}

module.exports = init_publications;
